import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import DepartmentService from 'services/departmentsService';
import { formatValidationErrors } from 'utils/ArrayUtils';

export const initialState = {
    list : [],
    fetching: false,
    creating: false,
    updating : false,
    deleting : false,
    errorMessages: [],
    showMessage: false,
    showEditForm : false,
    showNewForm : false,
}

export const fetchDepartments = createAsyncThunk('/fetchDepartments', async (data, { rejectWithValue }) => {
    try {
            const response = await DepartmentService.fetch();
            var code = response.code;	
            return {
                code: code,
                departmments : response.data
            };
    } catch (err) {
        let code = err.response?.data.code;
        let response = err.response;
        return rejectWithValue({
            code: code,
            errorMessages: response?.data?.message || 'Error'
        });
    }
});

export const createDepartment = createAsyncThunk('/createDepartment',async (data, { rejectWithValue }) => {
    try {
        const response = await DepartmentService.create(data)
        const code  = response.original.code;
        return {
            code: code,
            departmments : response.original.data
        };
    } catch (err) {
        return rejectWithValue({code : err.response.status, error : err.response?.data.errors} || {error : "Error creating a department"})
    }
})

export const updateDepartment = createAsyncThunk('/updateDepartment',async (data, { rejectWithValue }) => {
    try {
        const response = await DepartmentService.update(data)
        const code = response.original.code;
        return {
            code: code,
            departmments : response.original.data
        };
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const deleteDepartment = createAsyncThunk('/deleteDepartment',async (id, { rejectWithValue }) => {
    try {
        const response = await DepartmentService.delete(id)
        const code = response.original.code;
        return {
            code: code,
            departmments : response.original.data
        };
    } catch (err) {
        return rejectWithValue({error : "Error deleting a department"})
    }
})

export const departmentSlice = createSlice({
    name: 'departments',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.fetching = !state.fetching
        },
        toggleDepartmentEditForm : (state) => {
            state.showEditForm =  !state.showEditForm;
        },
        toggleDepartmentNewForm : (state) => {
            state.showNewForm  = !state.showNewForm        
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDepartments.pending, (state) => {
                state.fetching = true
            })
            .addCase(fetchDepartments.fulfilled, (state, action) => {
                state.fetching = false
                state.list = action.payload.departmments
            })
            .addCase(fetchDepartments.rejected, (state, action) => {
                state.fetching = false
            })
            .addCase(createDepartment.pending, (state) => {
                state.creating = true
            })
            .addCase(createDepartment.fulfilled, (state, action) => {
                state.creating = false
                state.list = action.payload.departmments
                state.showNewForm = !state.showNewForm;
            })
            .addCase(createDepartment.rejected, (state, action) => {
                if(action.payload.code == 422){
                    state.errorMessages = formatValidationErrors(action.payload.error)
                }
                else {
                    // state.errorMessages = action.payload.error;
                }
                state.creating = false;
            })
            .addCase(updateDepartment.pending, (state, action) => {
                state.updating = true
            })
            .addCase(updateDepartment.fulfilled, (state, action) => {
                state.updating = false
                state.list = action.payload.departmments
                state.showEditForm = !state.showEditForm
            })
            .addCase(updateDepartment.rejected, (state, action) => {
                state.errorMessages = action.payload
                state.updating = false
            })
            .addCase(deleteDepartment.pending, (state, action) => {
                state.deleting = true
            })
            .addCase(deleteDepartment.fulfilled, (state, action) => {
                state.deleting = false
                state.list = action.payload.departmments
            })
            .addCase(deleteDepartment.rejected, (state, action) => {
                state.deleting = false
            })
    },
})

export const { 
    showLoading,
    toggleDepartmentEditForm,
    toggleDepartmentNewForm
} = departmentSlice.actions

export default departmentSlice.reducer